import React, { useEffect } from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Team from './components/Team/Team';
import Services from './components/Services/Services';
import Reviews from './components/Reviews/Reviews';
import ContactForm from './components/ContactForm/ContactForm';
import Footer from './components/Footer/Footer';
import Lenis from '@studio-freight/lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './App.scss';

gsap.registerPlugin(ScrollTrigger);

function App() {
  useEffect(() => {
    // ---------------- Lenis ----------------
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
      smoothTouch: false,
      direction: 'vertical',
      gestureDirection: 'vertical',
    });

    window.lenis = lenis;

    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);

    // ---------------- Smooth Scroll for Anchors ----------------
    const handleAnchorClick = (e) => {
      const href = e.currentTarget.getAttribute('href');
      if (href && href.startsWith('#')) {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          if (window.lenis) {
            window.lenis.scrollTo(target, { offset: -80 }); // подстраиваем под высоту header’а
          } else {
            window.scrollTo({
              top: target.offsetTop - 80,
              behavior: 'smooth',
            });
          }
        }
      }
    };

    // навешиваем обработчики на все ссылки с #
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach((link) =>
      link.addEventListener('click', handleAnchorClick)
    );

    // ---------------- GSAP Scroll Animations ----------------
    gsap.from('.hero__text', {
      opacity: 0,
      y: 60,
      duration: 1,
      ease: 'power2.out',
      delay: 0.2,
    });

    gsap.from('.hero__image', {
      opacity: 0,
      y: 40,
      duration: 1,
      ease: 'power2.out',
      delay: 0.4,
    });

    gsap.from('.team__content', {
      scrollTrigger: {
        trigger: '.team',
        start: 'top 80%',
      },
      opacity: 0,
      y: 60,
      duration: 1,
      ease: 'power2.out',
    });

    gsap.from('.team__image', {
      scrollTrigger: {
        trigger: '.team',
        start: 'top 80%',
      },
      opacity: 0,
      y: 40,
      duration: 1,
      ease: 'power2.out',
      delay: 0.2,
    });

    gsap.from('.service-card__wrapper', {
      scrollTrigger: {
        trigger: '.services',
        start: 'top 80%',
      },
      opacity: 0,
      y: 80,
      duration: 1,
      ease: 'power2.out',
      stagger: 0.15,
    });

    gsap.from('.reviews h2', {
      scrollTrigger: {
        trigger: '.reviews',
        start: 'top 85%',
      },
      opacity: 0,
      y: 50,
      duration: 1,
      ease: 'power2.out',
    });

    gsap.from('.review-card', {
      scrollTrigger: {
        trigger: '.reviews',
        start: 'top 75%',
      },
      opacity: 0,
      y: 60,
      duration: 1,
      ease: 'power2.out',
      stagger: 0.2,
      delay: 0.3,
    });

    gsap.from('.contact__wrapper', {
      scrollTrigger: {
        trigger: '.contact',
        start: 'top 80%',
      },
      opacity: 0,
      y: 70,
      duration: 1.2,
      ease: 'power2.out',
    });

    gsap.from('.footer', {
      scrollTrigger: {
        trigger: '.footer',
        start: 'top 95%',
      },
      opacity: 0,
      duration: 1.5,
      ease: 'power1.out',
    });

    // очистка
    return () => {
      anchorLinks.forEach((link) =>
        link.removeEventListener('click', handleAnchorClick)
      );
      lenis.destroy();
    };
  }, []);

  return (
    <div className='app'>
      <Header />
      <Hero />
      <Team />
      <Services />
      <Reviews />
      <ContactForm />
      <Footer />
    </div>
  );
}

export default App;
